import React from "react";
import { Link } from "react-router-dom";
import Instagram from "../../assets/assets/instagram-logo.svg";
import Youtube from "../../assets/assets/youtube-logo.svg";
import Twitter from "../../assets/assets/twitter-logo.svg";
import Facebook from "../../assets/assets/facebook-logo.svg";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-left">Copyright © 2020 NIBSS.</div>

      <div className="footer-mid">
        <a href="/">Privacy Policy</a>
        <a href="/terms-and-conditions">Terms and Conditions</a>
      </div>

      <div className="footer-right">
        <Link to={"//www.instagram.com/nibssplc/"} target="_blank">
          <div className="footer-right-icon">
            <img src={Instagram} alt="instagram logo" />
          </div>
        </Link>
        <Link
          to={"//www.youtube.com/channel/UCLD7Y56uWlXKj_XxMA-61AQ"}
          target="_blank"
        >
          <div className="footer-right-icon">
            <img src={Youtube} alt="instagram logo" />
          </div>
        </Link>
        <Link to={"//www.facebook.com/NIBSSPLC"} target="_blank">
          <div className="footer-right-icon">
            <img src={Facebook} alt="facebook logo" />
          </div>
        </Link>
        <Link to={"//twitter.com/NIBSS_NG"} target="_blank">
          <div className="footer-right-icon">
            <img src={Twitter} alt="twitter logo" />
          </div>
        </Link>
      </div>
    </footer>
  );
};

export default Footer;
